import { TimelineOppositeContentClassKey } from '@material-ui/lab/TimelineOppositeContent';

const MuiTimelineOppositeContent = (): Partial<Record<TimelineOppositeContentClassKey, unknown>> => ({
    root: {
        paddingTop: 0,
        paddingBottom: 0,
    },
});

export default MuiTimelineOppositeContent;
